<template>
  <footer class="custom-footer">
    <div>
      <div class="row footer-margin">
        <div class="col-md-4 col-sm-4">
          <h3>Useful links</h3>
          <div class="mt-3">
            <ul>
              <li class="mb-2" v-if="loggedIn">
                <router-link to="/faq">FAQs</router-link>
              </li>
              <li class="mb-2">
                <a
                  target="_blank"
                  href="https://www.hungerhub.com/privacy-policy/"
                  >Privacy Policy</a
                >
              </li>
              <li class="mb-2" v-if="loggedIn">
                <router-link to="/terms-of-use">Terms of Use</router-link>
              </li>
              <li class="mb-2" v-else>
                <a
                  target="_blank"
                  href="https://www.hungerhub.com/terms-of-use/"
                  >Terms of Use</a
                >
              </li>
            </ul>
          </div>

          <div class="address">
            <p>
              180 John Street Toronto ON M5T 1X5
            </p>
          </div>
        </div>

        <div class="col-md-4 col-sm-4">
          <h3>Made with ♥️ in Canada</h3>

          <div>
            <p class="download-text">Download our Uncatering™ mobile app</p>
          </div>

          <div class="d-flex mb-4">
            <a
              class="btn p-0 mr-3"
              href="https://play.google.com/store/apps/details?id=com.uncatering.app&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
              role="button"
            >
              <img
                src="../assets/img/google-play-badge.png"
                alt="Get it on Google Play"
                class="app-badge"
              />
            </a>
            <a
              class="btn p-0"
              href="https://apps.apple.com/ca/app/uncatering-by-hungerhub/id1505624488"
              role="button"
            >
              <img
                src="../assets/img/apple-store-badge.png"
                alt="Get it on App Store"
                class="app-badge"
              />
            </a>
          </div>
        </div>

        <div class="col-md-4 col-sm-4" id="newsletter">
          <h3>Need Help?</h3>
          <div class="mt-3">
            <span>
              Start live chat with one of our agents.
              <br />Weekdays : 9 AM-7 PM
            </span>
          </div>
        </div>
      </div>
      <!-- End row -->
    </div>
    <!-- End container -->
  </footer>
</template>

<script>
import { isLoggedIn } from "../utils/api";

export default {
  name: "Footer",
  data() {
    return {
      loggedIn: false
    };
  },
  mounted() {
    this.isUserLoggedIn();
  },
  methods: {
    isUserLoggedIn() {
      if (isLoggedIn()) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
    }
  },
  watch: {
    $route(to, from) {
      this.isUserLoggedIn();
    }
  }
};
</script>

<style scoped lang="scss">
.custom-footer {
  background-color: #383781;

  h3 {
    font-family: Inter, sans-serif;
    line-height: 130%;
    font-weight: 600;
    margin-bottom: 32px;
    color: #fff;
    font-size: 20px;
  }

  span,
  a {
    font-family: Inter, sans-serif;
    color: #fff;
    font-weight: 300;
    font-size: 16px;
  }

  p {
    margin-top: 2px;
    font-family: Inter, sans-serif;
    color: #fff;
    font-size: 16px;
    line-height: 1.5;
    font-weight: 500;
  }

  .download-text {
    margin-bottom: 30px;
    font-family: Inter, sans-serif;
    font-weight: 600;
  }

  .app-badge {
    width: 170px;
    height: 50px;
    object-fit: fill;
  }

  .address {
    margin-top: 20px;
  }
}

footer {
  position: relative;
  z-index: 100;
}

.footer-margin {
  margin: 1% 7%;
}

.style-anchor-tag {
  text-decoration: none;
  border-bottom: 1px solid #b1d3d4;
}

@media (max-width: 615px) {
  .custom-footer {
    h3 {
      margin-bottom: 12px;
      font-size: 16px;
    }

    span,
    a {
      font-size: 13px;
    }

    p {
      font-size: 13px;
    }

    .download-text {
      margin-bottom: 10px;
    }

    .app-badge {
      width: 120px;
      height: 36px;
      object-fit: cover;
    }
    .address {
      margin-top: 0px;
    }
  }
}

@media (max-width: 305px) {
  .custom-footer {
    .app-badge {
      width: 90px;
      height: 26px;
      object-fit: cover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue